import { render } from "./Pepe.vue?vue&type=template&id=5cee770b"
import script from "./Pepe.vue?vue&type=script&lang=js"
export * from "./Pepe.vue?vue&type=script&lang=js"

import "./Pepe.vue?vue&type=style&index=0&id=5cee770b&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__